export default __webpack_public_path__ + "static/media/qandaForum.f0d3480c.png";